import { ChangeDetectionStrategy, Component, computed, input, ViewEncapsulation } from '@angular/core';
import { Visual } from '../Visual';
import { VisualStyleEditorComponent } from '../base/VisualStyleEditor.component';
import { CardVisual, CardVisualComponent } from './CardVisual.component';
import { VisualStyle } from '../VisualStyle';
import { PbiChartTypes } from 'src/app/shared/chart/chart';
import { ChartVisual } from '../highcharts/ChartVisual.component';

@Component({
  selector: 'pbir-visual__card-style-editor',
  templateUrl: './CardStyleEditor.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CardStyleEditorComponent extends VisualStyleEditorComponent<
  CardVisual.Options,
  CardVisual.State,
  CardVisual.Style> {
  readonly ChartTypes = [
    PbiChartTypes.barChart,
    PbiChartTypes.columnChart,
    PbiChartTypes.lineChart,
    PbiChartTypes.areaChart,
    PbiChartTypes.pieChart,
    PbiChartTypes.donutChart,
  ];

  get measure()      { return this.style().measure; }
  get numberFormat() { return this.style().numberFormat; };

  numberFormats = [...ChartVisual.NumberFormat.options].filter(x => x.id != ChartVisual.NumberFormat.Percentage);
}
